const DEFAULT_QUALITY = 75;

export const imageDeliveryUrl = ({ src, width, quality, mode }) => {
  if (mode !== 'cloudflare' || src.toLowerCase().split(/[?#]/, 1)[0].endsWith('.svg')) {
    return src;
  }

  const options = `width=${width},quality=${quality ?? DEFAULT_QUALITY},format=auto`;

  return `/cdn-cgi/image/${options}/${src}`;
};
